// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetTdgDocumentByExternalIdRequestModel from '../../model/get-tdg-document-by-external-id-request-model';
import GetTdgDocumentByExternalIdRequestDTO from '../dto/get-tdg-document-by-external-id-request-dto';
import dtoSchema from '../schemas/get-tdg-document-by-external-id-request-schema';

export default abstract class GetTdgDocumentByExternalIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetTdgDocumentByExternalIdRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<GetTdgDocumentByExternalIdRequestDTO>): GetTdgDocumentByExternalIdRequestModel;
  static toModel(dto: DeepPartial<GetTdgDocumentByExternalIdRequestDTO> | undefined | null): GetTdgDocumentByExternalIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetTdgDocumentByExternalIdRequestDTO> | undefined | null): GetTdgDocumentByExternalIdRequestModel | undefined {
    return dto ? new GetTdgDocumentByExternalIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetTdgDocumentByExternalIdRequestModel> | GetTdgDocumentByExternalIdRequestModel): GetTdgDocumentByExternalIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as GetTdgDocumentByExternalIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetTdgDocumentByExternalIdRequestModel, can not map to GetTdgDocumentByExternalIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
